import React from 'react'
import { markupAndSanitize, sanitize } from '@utils/sanitize'
import FormattedTime from '@components/FormattedTime'
import InTimelineImageWithModal from './InTimelineImageWithModal'
import type { Marker as MarkerType, Photo } from '@app-types/entity_types'
import { isJsonapiPhoto } from '@app-types/entity_types'
import type { Bounds } from '../../types/types'

type ExpandedMarkerContentProps = {
  marker: MarkerType
  photos: Record<string, Photo>
  expandedItemBounds: Bounds
}

const ExpandedMarkerContent: React.FC<ExpandedMarkerContentProps> = ({ marker, photos, expandedItemBounds }) => {
  const photoId = marker.photo_ids.length > 0 ? marker.photo_ids[0].toString() : null
  const photoData = photoId ? photos[photoId] : null

  const showImage = () => {
    if (!photoData) return false
    const photoAttributes = isJsonapiPhoto(photoData) ? photoData.attributes : photoData
    return photoAttributes.image_processing_complete === true
  }

  const photoAttributes = photoData ? (isJsonapiPhoto(photoData) ? photoData.attributes : photoData) : null
  const imageData = showImage() ? photoAttributes?.image_urls?.medium_landscape : null
  const modalImageData = showImage() ? photoAttributes?.image_urls?.medium : null

  const description = marker.description || null

  const timelineItemStyle: React.CSSProperties = {
    width: expandedItemBounds.width,
    height: expandedItemBounds.height,
  }

  return (
    <div className="timeline-item-detail" style={timelineItemStyle}>
      {imageData && modalImageData && (
        <InTimelineImageWithModal
          image={imageData}
          modalImage={modalImageData}
          containerWidth={expandedItemBounds.width}
          containerHeight={expandedItemBounds.height * 0.5}
          enableModalViewing={true}
        />
      )}
      <div className="timeline-item-detail__content p-t p-b">
        <div className="timeline-item-detail__meta p-x">
          <div className="timeline-item-detail__time">
            <FormattedTime dateTime={marker.date} />
          </div>
          <h2 className="timeline-item-detail__title">{sanitize(marker.title)}</h2>
        </div>
        {description && (
          <div
            className="timeline-item-detail__description block p-x"
            dangerouslySetInnerHTML={{ __html: markupAndSanitize(description) }}
          />
        )}
      </div>
    </div>
  )
}

export default ExpandedMarkerContent
